module.exports = __webpack_public_path__ + "img/Storage.a7557f1d.svg";